<template>
  <path d="M15.0258 13.8475L18.595 17.4158L17.4158 18.595L13.8475 15.0258C12.5197 16.0902 10.8683 16.6691 9.16663 16.6667C5.02663 16.6667 1.66663 13.3067 1.66663 9.16666C1.66663 5.02666 5.02663 1.66666 9.16663 1.66666C13.3066 1.66666 16.6666 5.02666 16.6666 9.16666C16.669 10.8683 16.0901 12.5198 15.0258 13.8475ZM13.3541 13.2292C14.4117 12.1416 15.0023 10.6837 15 9.16666C15 5.94332 12.3891 3.33332 9.16663 3.33332C5.94329 3.33332 3.33329 5.94332 3.33329 9.16666C3.33329 12.3892 5.94329 15 9.16663 15C10.6837 15.0024 12.1415 14.4118 13.2291 13.3542L13.3541 13.2292Z"/>
</template>

<script>
export default {
  name: "IconSearch"
}
</script>

<style scoped>

</style>